import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SearchStatus, TravelTypes } from '../../../constants';
import { updateTripRequest, updateTripStatusReset } from '../../../store/slices/trip';
import ConfirmModal from '../../ConfirmModal';

const TripUpdateConfirmModal = ({
  tripId,
  travelModeToRemove,
  itineraryId,
  toggleViewConfirmModal,
}) => {
  const { updateTripStatus } = useSelector((store) => store.trip);

  const dispatch = useDispatch();

  const handleCancel = () => {
    toggleViewConfirmModal();
  };

  useEffect(() => {
    if (updateTripStatus === SearchStatus.DONE) {
      toggleViewConfirmModal();
      dispatch(updateTripStatusReset());
    }
  }, [updateTripStatus, toggleViewConfirmModal, dispatch]);

  const handleOk = () => {
    dispatch(
      updateTripRequest({
        tripId,
        itineraryModeToRemove: travelModeToRemove,
        itineraryIdToRemove: itineraryId,
      }),
    );
  };

  return (
    <ConfirmModal
      onCancel={handleCancel}
      onConfirm={handleOk}
      message={`Are you sure to remove ${Object.keys(TravelTypes)[travelModeToRemove]} from trip?`}
      event="RemoveFromTrip"
    />
  );
};

TripUpdateConfirmModal.propTypes = {
  travelModeToRemove: PropTypes.number.isRequired,
  tripId: PropTypes.string.isRequired,
  itineraryId: PropTypes.number,
  toggleViewConfirmModal: PropTypes.func.isRequired,
};

TripUpdateConfirmModal.defaultProps = {
  itineraryId: 0,
};

export default TripUpdateConfirmModal;
